import { Component, OnInit, inject } from '@angular/core';
import {DataService} from '../../services/data.service';
import {Router, RouterLink} from '@angular/router';
import {AccessService} from '../../services/access.service';
import {LocalStorageService} from '../../services/local-storage.service';
import {environment} from '../../../environments/environment';
import {ToastrService} from "ngx-toastr";
import {map} from "rxjs/operators";
import {FormsModule} from "@angular/forms";

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    imports: [
        FormsModule,
        RouterLink
    ],
    styleUrl: './login.component.scss'
})
export class LoginComponent implements OnInit {

    private dataService = inject(DataService);
    private router = inject(Router);
    private accessService = inject(AccessService);
    private localStorageService = inject(LocalStorageService);
    private toastrService = inject(ToastrService);

    email: string = environment.username
    password: string = environment.password
    showLogin = false;

    ngOnInit(): void {
        const token = this.localStorageService.getItem('token');

        if (token) {
            this.accessService.token = token;
            this.dataService.request("User/get").subscribe(response => {
                if (!response.error) {
                    this.accessService.user = response.user;
                    this.router.navigate(['/dashboard']);
                } else {
                    this.showLogin = true;
                }
            });
        } else {
            this.showLogin = true;
        }
    }

    login(): void {
        this.dataService.request("User/login", {
            email: this.email,
            password: this.password
        }).subscribe(response => {
            if (response.error === false) {
                this.email = '';
                this.password = '';
                this.accessService.token = response.token;
                this.accessService.user = response.user;
                this.localStorageService.setItem('token', response.token);
                this.router.navigate(['/dashboard']);
                this.toastrService.success('Login erfolgreich');
            } else {
                this.toastrService.error(response.error);
            }
        });
    }
}
